<!-- Parent dashboard -->
<!-- <div
  *ngIf="role === '4'"
  class="flex justify-center dashboard__children-holder"
>
  <div class="dashboard__children">
    <span>
      {{
        childrenLoading
          ? "Fetching Children"
          : children.length > 0
          ? "View data for"
          : "No children found"
      }}
    </span>
    <mat-select
      [(value)]="selectedChild"
      (selectionChange)="setchildren()"
      class="capitalize dashboard__children__select"
      *ngIf="!childrenLoading && children.length > 0"
    >
      <mat-option
        *ngFor="let child of children; let i = index"
        class="capitalize"
        [value]="i"
        >{{ child.first_name }}</mat-option
      >
    </mat-select>
  </div>
</div> -->

<!-- ** New Dashboard -->
<div
  id="dashboard"
  class="dashboard d-flex"
  [ngClass]="{ 'no-top-margin': roleId == '4' }"
>
  <!-- ** left pane -->
  <div
    id="dashboard-pane-left"
    class="dashboard-pane-left d-flex flex-d-column g-1 p-1"
  >
    <!-- ** header -->
    <div
      id="dashboard-pane-left-header"
      class="dashboard-pane-left-header d-flex g-2 justify-space-between items-center pl-2 pr-2"
    >
      <div
        id="dashboard-pane-left-header-title"
        class="dashboard-pane-left-header-title"
      >
        Dashboard
      </div>
      <!-- <div
        id="dashboard-pane-left-header-searchBar"
        class="dashboard-pane-left-header-searchBar d-flex g-1 items-center"
      >
        <img
          id="dashboard-pane-left-header-searchBar-searchIcon"
          class="dashboard-pane-left-header-searchBar-searchIcon"
          src="assets/images/dashboard/search-icon.svg"
        />
        <span
          id="dashboard-pane-left-header-searchBar-text"
          class="dashboard-pane-left-header-searchBar-text"
        >
          Search
        </span>
      </div> -->
      <div
        id="dashboard-pane-left-header-dateTime"
        class="dashboard-pane-left-header-dateTime d-flex flex-d-column"
      >
        <span
          id="dashboard-pane-left-header-dateTime-time"
          class="dashboard-pane-left-header-dateTime-time"
        >
          {{ time }}
        </span>
        <span
          id="dashboard-pane-left-header-dateTime-date"
          class="dashboard-pane-left-header-dateTime-time"
        >
          {{ date }}
        </span>
      </div>
    </div>
    <!-- ** assignments -->
    <div
      *ngIf="!assignmentsLoading && assignments.length > 0"
      id="dashboard-pane-left-assignments"
      class="dashboard-pane-left-assignments pl-1 pr-1 pb-1"
    >
      <div
        id="dashboard-pane-left-assignments-title-holder"
        class="dashboard-pane-left-assignments-title-holder pt-1 pl-1 pr-1"
      >
        <div
          id="dashboard-pane-left-assignments-title"
          class="dashboard-pane-left-assignments-title"
        >
          Due Assignments
        </div>
        <mat-divider
          id="dashboard-pane-left-assignments-divider"
          class="dashboard-pane-left-assignments-divider"
        ></mat-divider>
      </div>
      <div
        id="dashboard-pane-left-assignments-assignment-holder"
        class="dashboard-pane-left-assignments-assignment-holder d-flex flex-d-column g-1"
      >
        <div
          *ngFor="let assignment of assignments; let assignmentIndex = index"
          id="dashboard-pane-left-assignments-assignment"
          class="dashboard-pane-left-assignments-assignment d-flex g-2"
        >
          <div
            id="dashboard-pane-left-assignments-assignment-dueByCard"
            class="dashboard-pane-left-assignments-assignment-dueByCard d-flex flex-d-column items-center"
          >
            <span
              id="dashboard-pane-left-assignments-assignment-dueByCard-type"
              class="dashboard-pane-left-assignments-assignment-dueByCard-type"
              >{{ assignment.assignmentType }}</span
            >
            <span
              id="dashboard-pane-left-assignments-assignment-dueByCard-text"
              class="dashboard-pane-left-assignments-assignment-dueByCard-text"
              >Due by</span
            >
            <span
              id="dashboard-pane-left-assignments-assignment-dueByCard-date"
              class="dashboard-pane-left-assignments-assignment-dueByCard-date"
              >{{ assignment.dueByDate }}</span
            >
          </div>
          <div
            id="dashboard-pane-left-assignments-assignment-content"
            class="dashboard-pane-left-assignments-assignment-content d-flex flex-d-column justify-space-evenly"
          >
            <div
              id="dashboard-pane-left-assignments-assignment-content-title"
              class="dashboard-pane-left-assignments-assignment-content-title"
              [routerLink]="
                assignment.type === 'test'
                  ? ['/new-dashboard']
                  : ['/academic-coaching']
              "
              [ngClass]="{ pointer: assignment.type === 'assignment' }"
            >
              {{ assignment.name }}
            </div>
            <div
              id="dashboard-pane-left-assignments-assignment-content-date"
              class="dashboard-pane-left-assignments-assignment-content-date"
            >
              {{ assignment.assignedDate }}
            </div>
          </div>
          <div
            id="dashboard-pane-left-assignments-assignment-content"
            class="dashboard-pane-left-assignments-assignment-content d-flex flex-d-column justify-space-evenly dashboard-pane-left-assignments-assignment-status"
            *ngIf="assignment.type === 'test' || assignment.type === 'workshop'"
          >
            <div
              id="dashboard-pane-left-assignments-assignment-content-title"
              class="dashboard-pane-left-assignments-assignment-content-title"
            >
              {{ assignment.testTypeName }}
            </div>
            <div
              id="dashboard-pane-left-assignments-assignment-content-date"
              class="dashboard-pane-left-assignments-assignment-content-date"
            >
              {{
                assignment.status === 3
                  ? "Completed"
                  : assignment.status === 2
                  ? "Started"
                  : assignment.status === 4
                  ? "Expired"
                  : "Not Started"
              }}
            </div>
          </div>
          <button
            *ngIf="
              (assignment.type === 'test' || assignment.type === 'workshop') &&
              ((role !== '4' && assignment.status !== 4) ||
                (role === '4' && assignment.status === 3))
            "
            (click)="goToTestOrWorkshop(assignment)"
            class="dashboard-pane-left-assignments__button"
          >
            {{
              assignment.type === "test"
                ? assignment.status === 3
                  ? "View Report"
                  : assignment.status === 2
                  ? "Continue Test"
                  : "Start Test"
                : (assignment.status === 1
                    ? "Start "
                    : assignment.status === 2
                    ? "Continue "
                    : "View ") + "workshop"
            }}
          </button>
        </div>
      </div>
    </div>
    <div
      *ngIf="assignmentsLoading || assignments.length === 0"
      class="dashboard-pane-left-no-assignments"
    >
      {{ assignmentsLoading ? "Loading..." : "No assignments found!" }}
    </div>
  </div>
  <!-- ** right pane -->
  <div
    id="dashboard-pane-right"
    class="dashboard-pane-right d-flex flex-d-column g-1"
  >
    <!-- ** right header (userinfo) -->
    <!--div
      id="dashboard-pane-right-header"
      class="dashboard-pane-right-header d-flex justify-end"
    >
      <!- ** userinfo component (selector) ->
      <!- <app-common-user-info></app-common-user-info>
    </div-->
    <!-- ** next classes -->
    <div
      id="dashboard-pane-right-nextClasses"
      class="dashboard-pane-right-nextClasses"
      *ngIf="studentAccess?.academic || studentAccess?.testPrep"
    >
      <div
        id="dashboard-pane-right-nextClasses-title-holder"
        class="dashboard-pane-right-nextClasses-title-holder"
      >
        <div
          id="dashboard-pane-right-nextClasses-title"
          class="dashboard-pane-right-nextClasses-title"
        >
          Upcoming Classes
        </div>
        <mat-divider
          id="dashboard-pane-right-nextClasses-divider"
          class="dashboard-pane-right-nextClasses-divider"
        ></mat-divider>
      </div>
      <div
        *ngIf="!eventsLoading && eventsFromNote"
        class="dashboard-pane-right-nextClasses-note"
      >
        {{ eventsFromNote }}
      </div>
      <!-- ** each next class -->
      <div
        *ngIf="!eventsLoading && events.length > 0"
        id="dashboard-pane-right-nextClasses-holder"
        class="dashboard-pane-right-nextClasses-holder d-flex flex-d-column g-1"
      >
        <div
          *ngFor="let event of events; let eventIndex = index"
          id="dashboard-pane-right-nextClasses-nextClass"
          class="dashboard-pane-right-nextClasses-nextClass d-flex g-1"
          [ngStyle]="{
            'background-color': event.colors.tint,
            'border-left-color': event.colors.accent
          }"
        >
          <img
            src="assets/images/dashboard/new-class3x.webp"
            width="65px"
            height="64px"
          />
          <!-- Hidden classes (e.g. holidays) show only their title and date -->
          <div
            *ngIf="event.hideDetails === 1"
            class="dashboard-pane-right-nextClasses-nextClass-content d-flex justify-space-between"
          >
            <span
              class="dashboard-pane-right-nextClasses-nextClass-content-classInfo-classTitle"
              >{{ event.title }}</span
            >
            <span
              class="dashboard-pane-right-nextClasses-nextClass-content-classControls-classDate"
              >{{ event.displayDayString }}</span
            >
          </div>
          <div
            *ngIf="event.hideDetails !== 1"
            id="dashboard-pane-right-nextClasses-nextClass-content"
            class="dashboard-pane-right-nextClasses-nextClass-content d-flex justify-space-between"
          >
            <div
              id="dashboard-pane-right-nextClasses-nextClass-content-classInfo"
              class="dashboard-pane-right-nextClasses-nextClass-content-classInfo d-flex flex-d-column"
            >
              <span
                *ngIf="event.title"
                id="dashboard-pane-right-nextClasses-nextClass-content-classInfo-classTitle"
                class="dashboard-pane-right-nextClasses-nextClass-content-classInfo-classTitle"
                >{{ event.title }}</span
              >
              <span
                id="dashboard-pane-right-nextClasses-nextClass-content-classInfo-courseName"
                class="dashboard-pane-right-nextClasses-nextClass-content-classInfo-courseName"
                >{{ event.course }} - {{ event.subject_display_name }}</span
              >
              <span
                id="dashboard-pane-right-nextClasses-nextClass-content-classInfo-tutorName"
                class="dashboard-pane-right-nextClasses-nextClass-content-classInfo-tutorName"
                >Tutor: {{ event.tutor }}</span
              >
              <span
                id="dashboard-pane-right-nextClasses-nextClass-content-classInfo-classTime"
                class="dashboard-pane-right-nextClasses-nextClass-content-classInfo-classTime"
                >{{ event.startTime }} ({{ timezone }})</span
              >
            </div>
            <div
              id="dashboard-pane-right-nextClasses-nextClass-content-classControls"
              class="dashboard-pane-right-nextClasses-nextClass-content-classControls d-flex flex-d-column"
            >
              <span
                id="dashboard-pane-right-nextClasses-nextClass-content-classControls-classType"
                class="dashboard-pane-right-nextClasses-nextClass-content-classControls-classType"
                >{{ event.type_display_name }}</span
              >
              <span
                id="dashboard-pane-right-nextClasses-nextClass-content-classControls-classDate"
                class="dashboard-pane-right-nextClasses-nextClass-content-classControls-classDate"
                >{{ event.displayDayString }}</span
              >
              <a
                id="dashboard-pane-right-nextClasses-nextClass-content-classControls-joinButton"
                class="dashboard-pane-right-nextClasses-nextClass-content-classControls-joinButton"
                target="_blank"
                [href]="event.classUrl"
                [ngStyle]="{
                  'background-color': event.colors.accent
                }"
                >Join</a
              >
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="eventsLoading || events.length === 0">
        {{ eventsLoading ? "Loading..." : "No upcoming classes" }}
      </div>
    </div>
    <!-- ** practice stats -->
    <!-- <div
      id="dashboard-pane-right-practiceStats"
      class="dashboard-pane-right-practiceStats"
    >
      <div
        id="dashboard-pane-right-practiceStats-title-holder"
        class="dashboard-pane-right-practiceStats-title-holder"
      >
        <div class="d-flex g-1">
          <div
            id="dashboard-pane-right-practiceStats-title"
            class="dashboard-pane-right-practiceStats-title"
          >
            Practice Stats
          </div>
          <img
            src="assets/images/dashboard/practice-stats3x.webp"
            width="48px"
            height="48px"
          />
        </div>
        <mat-divider
          id="dashboard-pane-right-practiceStats-divider"
          class="dashboard-pane-right-practiceStats-divider"
        ></mat-divider>
        <div
          id="dashboard-pane-right-practiceStats-countTitles"
          class="dashboard-pane-right-practiceStats-countTitles d-flex justify-space-between"
        >
          <span>Activity</span>
          <div
            class="dashboard-pane-right-practiceStats-countTitles-rightSection d-flex justify-end"
          >
            <span>Due</span>
            <span>Ongoing</span>
            <span>Done</span>
          </div>
        </div>
      </div>
      <!-- ** each practice stat --
      <div
        id="dashboard-pane-right-practiceStats-holder"
        class="dashboard-pane-right-practiceStats-holder d-flex flex-d-column g-1"
      >
        <div
          *ngFor="
            let practiceStat of practiceStats;
            let practiceStatIndex = index
          "
          id="dashboard-pane-right-practiceStats-practiceStat"
          class="dashboard-pane-right-practiceStats-practiceStat d-flex g-5"
        >
          <div
            id="dashboard-pane-right-practiceStats-practiceStat-activity-holder"
            class="dashboard-pane-right-practiceStats-practiceStat-activity-holder d-flex justify-space-between items-center"
          >
            <span
              id="dashboard-pane-right-practiceStats-practiceStat-activity-text"
              class="dashboard-pane-right-practiceStats-practiceStat-activity-text"
            >
              {{ practiceStat.activity }}
            </span>
            <div
              id="dashboard-pane-right-practiceStats-practiceStat-activityScores-holder"
              class="dashboard-pane-right-practiceStats-practiceStat-activityScores-holder d-flex g-4 justify-end items-center"
            >
              <span
                id="dashboard-pane-right-practiceStats-practiceStat-activityScores-due"
                class="dashboard-pane-right-practiceStats-practiceStat-activityScores-due"
                >{{ practiceStat.due }}</span
              >
              <span
                id="dashboard-pane-right-practiceStats-practiceStat-activityScores-ongoing"
                class="dashboard-pane-right-practiceStats-practiceStat-activityScores-ongoing"
                >{{ practiceStat.ongoing }}</span
              >
              <span
                id="dashboard-pane-right-practiceStats-practiceStat-activityScores-done"
                class="dashboard-pane-right-practiceStats-practiceStat-activityScores-done"
                >{{ practiceStat.done }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</div>
<app-chart *ngIf="hasChartAccess" [studentId]="studentId"></app-chart>
